import { render } from "./basicConfig.vue?vue&type=template&id=2326f0a5"
import script from "./basicConfig.vue?vue&type=script&lang=js"
export * from "./basicConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__